import React, {  useState } from 'react';
import { Tooltip } from 'antd';
import 'antd/dist/reset.css';
import { useTranslation } from 'react-i18next';
import { truncate } from 'lodash';


// const donationCollected= 120
// const goalAmount = 200
const DonationFormCard = ({campaign}) => {
  const {t} = useTranslation()
  const [progressValue, setProgressValue] = useState(124); // Initial value
  const maxValue = 5054;

  const goalAmount = Number(campaign?.amount) || 0;
  const raisedAmount = Number(campaign?.recievedDonation) || 0;
  // Guard the divide-by-zero, and clamp: lowering a goal below what has
  // already been raised otherwise sends the fill and its label out of the
  // container.
  const progressPercentage =
    goalAmount > 0
      ? Math.max(0, Math.min(100, (raisedAmount / goalAmount) * 100))
      : 0;

  const handleProgressChange = (event) => {
    const value = event.target.value;
    setProgressValue(value);
  };

  // Rendering before the fetch resolves showed the donor
  // "€undefined ... NaN% completed". Wait for the campaign.
  if (!campaign) return null;


  return (
    <div className='donation-form-card'>
      {/* Image */}
      <div className='donation-form-card-img-container'>
        <img
          src={campaign?.preview_image}
          alt={t("Donation")}
        />
      </div>

      {/* Text and Progress Bar */}
      <div style={{ flex: 1}}>
        {/* Text */}
        <div style={{ marginBottom: '20px' }}>
          <h3 style={{color:'#1a1a1a',fontSize:'20px', fontWeight:600,lineHeight:'34px'}}>{truncate(campaign?.title,{length:40})} </h3>
        </div>
        <p style={{fontSize:'16px',fontWeight:500, color:'#7E7E7E', marginBottom:'12px', textAlign:'left'}}><span style={{color:'#00AC4F', fontWeight:700}}>&euro;{raisedAmount} {t('raised')}</span> {t('out of')} &euro;{goalAmount}</p>

        {/* Progress Bar */}
        <div className="progress-bar">
          <div
            className="progress-bar-fill"
            style={{ width: `${progressPercentage}%` }} // Dynamically set width
          >
          </div>
          <div
            className="progress-bar-label"
            style={{ left: `${progressPercentage}%` }} // Adjust the label position
          >
            €{raisedAmount}
          </div>
        </div>
        <div style={{fontSize:'16px', marginTop:'12px'}} className="progress-info">
        <div>{progressPercentage.toFixed(1)}% {t('completed')}</div>
        <div>{campaign?.user_ids?.length || 0} {t("donations")}</div>
      </div>
      </div>
    </div>
  );
};

export default DonationFormCard;
